/************
 * Developed by : Shiva Software Solutions
 * Date : 29-11-2024
 * Descriptions :MRD User Reducers
 ************/
import {
  MRD_CLIENT_LIST,
  MRD_API_RES,
  MRD_USER_LIST,
  MRD_RECORD_LIST,
  MRD_RECORD_LIST_COUNT,
  ADMIN_COUNT,
  ADMIN_EXCEL_LIST,
  ADMIN_LIST,
  CLIENT_DRLIST,
  CLIENT_CREDLIST,
  MRD_DUPLICATE_OPID,
  UPLOAD_WARNING,
  MRD_EXCEL_DATA,
  MRD_EXCEL_DATA_COUNT,
  EDIT_MRD,
  MRD_LABRE_EXCEL,
  MRD_LABRE_LIST,
  MRD_LABRE_COUNT,
  MRD_LABPAGE_COUNT,
  EXCEL_INSERT_MSG,
  INSERT_ERROR_INDEX,
} from '../../shared/constants/ActionTypes';
const initialState = {
  mrdClientList: [],
  mrdLabpageCount:0,
  apiResponse: '',
  mrdUserList: [],
  mrdRecordList: [],
  mrdRecordListCount: 0,
  adminList: [],
  adminExcelList: [],
  adminCount: {},
  clientDrList: [],
  clientCredList: [],
  mrdDuplicateOpid: '',
  uploadWarning: '',
  mrdLabReExcel: [],
  editMRD: '',
  mrdLabReList: [],
  medLabReCount: 0,
  excelInsertMsg: '',
  inserErrorIndex: [],
};
const mrdUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case MRD_LABPAGE_COUNT:
      return {
        ...state,
        mrdLabpageCount: action.payload,
      };
    case MRD_LABRE_EXCEL:
      return {
        ...state,
        mrdLabReExcel: action.payload,
      };
    case MRD_LABRE_LIST:
      return {
        ...state,
        mrdLabReList: action.payload,
      };
    case MRD_LABRE_COUNT:
      return {
        ...state,
        medLabReCount: action.payload,
      };
    case MRD_CLIENT_LIST:
      return {
        ...state,
        mrdClientList: action.payload,
      };

    case CLIENT_DRLIST:
      return {
        ...state,
        clientDrList: action.payload,
      };
    case CLIENT_CREDLIST:
      return {
        ...state,
        clientCredList: action.payload,
      };
    case ADMIN_LIST:
      return {
        ...state,
        adminList: action.payload,
      };
    case ADMIN_EXCEL_LIST:
      return {
        ...state,
        adminExcelList: action.payload,
      };
    case ADMIN_COUNT:
      return {
        ...state,
        adminCount: action.payload,
      };
    case MRD_RECORD_LIST_COUNT:
      return {
        ...state,
        mrdRecordListCount: action.payload,
      };
    case MRD_USER_LIST:
      return {
        ...state,
        mrdUserList: action.payload,
      };
    case MRD_RECORD_LIST:
      return {
        ...state,
        mrdRecordList: action.payload,
      };
    case MRD_API_RES:
      return {
        ...state,
        apiResponse: action.payload,
      };
    case MRD_DUPLICATE_OPID:
      return {
        ...state,
        mrdDuplicateOpid: action.payload,
      };
    case UPLOAD_WARNING:
      return {
        ...state,
        uploadWarning: action.payload,
      };
    case MRD_EXCEL_DATA:
      return {
        ...state,
        mrdExcelData: action.payload,
      };
    case MRD_EXCEL_DATA_COUNT:
      return {
        ...state,
        mrdExcelDataCount: action.payload,
      };
    case EDIT_MRD:
      return {
        ...state,
        editMRD: action.payload,
      };
    case EXCEL_INSERT_MSG:
      return {
        ...state,
        excelInsertMsg: action.payload,
      };
    case INSERT_ERROR_INDEX:
      return {
        ...state,
        inserErrorIndex: action.payload,
      };
    default:
      return state;
  }
};
export default mrdUserReducer;
